import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { Button } from "./button";
import { LittleSubHeadline, LittleText, TextBody } from "../typography";

export default function DropdownDataItem({
  isActive,
  firstLabel,
  subLabel,
  btnText,
  isAddItem = false,
  onClick,
}: {
  isActive?: string;
  firstLabel: string;
  subLabel: string;
  btnText: string;
  isAddItem?: boolean;
  onClick: () => void;
}) {
  return (
    <ClientCompanyItem $isAddItem={isAddItem} data-type={isActive}>
      <span>
        <LittleSubHeadline>{firstLabel}</LittleSubHeadline>
        <LittleText>{subLabel}</LittleText>
      </span>

      <Button
        bgcolor={isAddItem ? COLORS["light-blue"] : COLORS.gray}
        txtcolor={COLORS.secondary1}
        brcolor={isAddItem ? COLORS.secondary1 : "transparent"}
        width=""
        type="small"
        className={isAddItem ? `px-2` : ""}
        onClick={onClick}
      >
        <LittleText>{btnText}</LittleText>
      </Button>
    </ClientCompanyItem>
  );
}

const ClientCompanyItem = styled.div<{ $isAddItem: boolean }>`
  && {
    display: flex;
    align-items: center;
    gap: 24px;
    justify-content: space-between;
    background-color: ${COLORS.white};
    border: 2px solid ${COLORS.white};

    width: 100%;
    margin: 4px 0;
    padding: 10px !important;
    border-radius: 8px;

    &[data-type="active"] {
      border-color: ${COLORS.blue};
    }

    ${Button} {
      padding: 4px 8px;
      ${LittleText} {
        padding-right: 0;

        white-space: ${({ $isAddItem }) => ($isAddItem ? "pre-line" : "")};
      }
    }
    span {
      display: flex;
      flex-direction: column;
      padding: 0;
      background-color: transparent;
      cursor: default;
      ${LittleText} {
        color: ${COLORS["bg-text-color"]} !important;
        padding-right: 0;
      }
      ${LittleSubHeadline} {
        color: ${COLORS.secondary1};
        /* white-space: nowrap; */
      }
    }
  }
`;

export function DropdownButtonItem({
  value,
  isActive = false,
  bgColor,
  txtColor,
  brColor,
  brRadius,
  btnType,
  clickFunc,
  classes,
}: {
  value: string;
  isActive?: boolean;
  bgColor: string;
  txtColor: string;
  brColor: string;
  brRadius?: string;
  btnType: "large" | "small";
  clickFunc: () => void;
  classes?: string;
}) {
  return (
    <Button
      bgcolor={bgColor}
      txtcolor={txtColor}
      brcolor={brColor}
      width="100%"
      type={btnType}
      brradius={brRadius}
      className={classes}
      onClick={clickFunc}
    >
      <TextBody>{value}</TextBody>
    </Button>
  );
}
